(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible-row"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('details.accordion__details[name^="collapsible-rows-"]')) return;
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(details.open));
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review-avatars"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.hj-review-avatars__link');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#') || href.length === 1) return;

    let targetId;
    try {
      targetId = decodeURIComponent(href.slice(1));
    } catch {
      return;
    }

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();

    if (window.location.hash === href) {
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
    }

    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  }, true);
  } catch(e) { console.error(e); }
})();

})();
